(function () {
  function initLoginHub(root) {
    if (!root || root.getAttribute('data-ktob-login-hub-init') === '1') return;
    root.setAttribute('data-ktob-login-hub-init', '1');

    var modal = document.querySelector('[data-ktob-recover-modal]');
    var openBtn = root.querySelector('[data-ktob-open-recover]');
    var closeBtns = document.querySelectorAll('[data-ktob-close-recover]');
    var successBanner = root.querySelector('[data-ktob-recover-success]');
    var passwordToggle = root.querySelector('[data-ktob-password-toggle]');
    var passwordInput = root.querySelector('#KtobCustomerPassword');

    if (new URLSearchParams(window.location.search).get('recover') === 'sent' && successBanner) {
      successBanner.hidden = false;
    }

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      var emailInput = root.querySelector('#KtobCustomerEmail');
      var recoverEmail = root.querySelector('#KtobRecoverEmail');
      if (emailInput && recoverEmail && emailInput.value) {
        recoverEmail.value = emailInput.value;
      }
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
    }

    if (openBtn) openBtn.addEventListener('click', openModal);
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    if (passwordToggle && passwordInput) {
      passwordToggle.addEventListener('click', function () {
        var isPassword = passwordInput.type === 'password';
        passwordInput.type = isPassword ? 'text' : 'password';
        passwordToggle.textContent = isPassword ? '非表示' : '表示';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ktob-login-hub-root]').forEach(initLoginHub);
  });
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ktob-login-hub-root]');
    if (root) initLoginHub(root);
  });
})();
